import { BannerTiny } from 'components/banner-tiny/banner-tiny';
import { useTranslation } from 'react-i18next';

import { WalletOutline } from '@olist/design-system-icons';

import { InvalidRevenueCard, InvalidRevenueContent } from './invalid-revenue.styles';

const InvalidRevenue = () => {
  const { t } = useTranslation();
  const MAX_VALUE = '199.999';

  return (
    <InvalidRevenueCard>
      <div>
        <WalletOutline color="#0C29D0" width={24} height={24} />
      </div>
      <InvalidRevenueContent>
        <h3>{t`revenue below the recommended average`}</h3>
        <p>
          {t(
            `Based on internal analyses, we identified that stores with monthly revenues above R$ {{MAX_VALUE}} have better sales performance with Olist Store. Therefore, we recommend that you currently advertise on marketplaces using Tiny, which is part of the Olist Group.`,
            {
              MAX_VALUE,
            }
          )}
        </p>

        <p>
          {' '}
          {t`Tiny is a management system with integration hub capabilities. With it, you can:`}
        </p>

        <ul>
          <li>
            {t`Advertise products on dozens of marketplaces, such as Mercado Livre, Shopee, Amazon, Americanas and Aliexpress`}
          </li>
          <li>{t`Control products, stock, prices and orders in a few clicks`}</li>
          <li>{t`Issue invoices automatically`}</li>
          <li>{t`Reduce operational errors and gain efficiency`}</li>
        </ul>
        <p>
          {t`Take advantage of the special conditions we have available for you and hire Tiny with a super discount on the monthly fee.`}
        </p>
        <BannerTiny />
      </InvalidRevenueContent>
    </InvalidRevenueCard>
  );
};

export { InvalidRevenue };
